import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";

import { calcularMonto, calcularTotal, formatCapital } from "../../../../../utils/utils";
import { deudasService } from "../../../../../_services/deudas.service";
import { registrosService } from "../../../../../_services/registros.service";
import LoadingModal from "../../../../../components/LoadingModal/LoadingModal";
import PlanDePagoModal from "../../../../../components/PlanDePagoModal/PlanDePagoModal";
import { useUser } from "../../../../../hooks/useUser";
import "./RowDeudas.css";

export const RowDeudas = ({ record, inmuebles, abogados, situaciones=[] }) => {
  const [data, setData] = useState("");
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState("");

  const [deuda, setDeuda] = useState();
  const [legal, setLegal] = useState();
  const [planPago, setPlanPago] = useState();
  const [nroPlan, setNroPlan] = useState();
  const [abogado, setAbogado] = useState();

  const [showPlan, setShowPlan] = useState(false);
  const [planDePago, setPlanDePago] = useState(false);

  const user = useUser();

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        let res = await deudasService.getDeuda({ recurso: record.RECURSO, imponible: record.NRO_INMUEBLE });

        if (res.status === 200) {
          let response = await registrosService.findRegistros({ recurso: record.RECURSO, inmueble: record.NRO_INMUEBLE });

          if (response?.length) {
            let array = response.map(item => {
              const { apellido, nombre, user, registro_documentos } = item;

              return {
                ...item,
                apellido_nombre: `${apellido?.toUpperCase()}, ${nombre}`,
                asignado: `${user.apellido?.toUpperCase()}, ${user.nombre} (${user.abogado})`,
                documentos: registro_documentos?.length ? (
                  <div>
                    <ul>
                      {registro_documentos.map((e, i) => {
                        return (
                          <li key={(e.name || e.documento) + i}>
                            <a
                              href={"https://staticcontent.sannicolasciudad.gob.ar/images/gestion-deudas/registros/" + e.documento}
                              key={e.documento}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {e.documento}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : null
              };
            });
            setRegistros(array);
          }

          setData(res.data);
          setLoading(false);
        }
        else {
          setData("");
          setLoading(false);
        }
      }
      catch (err) {
        setData("");
        setLoading(false);
      }
    };

    if (inmuebles) {
      setData("");
      getData();
    }
    else {
      setData(record);
    }

    return () => {
      setData("");
    };

  }, [inmuebles]);

  useEffect(() => {
    if (inmuebles) {
      setData("");
    }
    else {
      setData(record);
    }

    return () => {
      setData("");
    };

  }, [inmuebles]);

  function sliceByYear(arr) {
    let result = [];
    let temp = null;
    let tempIndx = 0;

    for (let i = 0; i < arr.length; i++) {
      if (temp && arr[i].ANIO !== temp) {
        let chunk = arr.slice(tempIndx, i);
        tempIndx = i;
        temp = arr[i].ANIO;

        result.push(chunk);
      }
      temp = arr[i].ANIO;
    }
    let chunk = arr.slice(tempIndx, arr.length);
    result.push(chunk);
    return result;
  }

  function formatDeudas(array) {
    if (array && array.length) {
      let resultSlice = sliceByYear(array);

      let result = resultSlice.reduce((a, b) => {        
        b.forEach((e) => {
          const situacion = situaciones.find((s) => s.CODIGO === e.SITUACION);

          if (a[e.SITUACION]) {
            a[e.SITUACION] = {
              ...a[e.SITUACION],
              [e.ANIO]: {
                anio: e.ANIO,
                legal: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].legal ? a[e.SITUACION][e.ANIO].legal : e.LEGAL,
                periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
                estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                situacion: situacion. DETALLE_SITUACION
              }
            };
          }
          else {
            a[e.SITUACION] = {
              [e.ANIO]: {
                anio: e.ANIO,
                legal: e.LEGAL ? e.LEGAL : "",
                periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
                estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                situacion: situacion. DETALLE_SITUACION
              }
            };
          }
        }
        );
        return a;
      }, {}
      );
      return result;
    } else {
      return false;
    }
  }

  useEffect(() => {
    let deudas = formatDeudas(data.deuda);
    let legales = formatDeudas(data.legal);

    if (data.planpago) {
      let planpago = data.planpago.reduce((prev, current) => {
        if (prev.length) {
          if (prev.some(e => e.NRO_PLAN === current.NRO_PLAN)) {
            return prev;
          }
          else {
            return [...prev, current];
          }
        }
        else {
          return [current];
        }
      }, []);

      setPlanPago(data.planpago);
      setNroPlan(planpago);
    }


    if (deudas && deudas["V"]) {
      let a = Object.values(deudas["V"]);
      setDeuda(a);
    }
    if (legales) {
      let b = [];

      if (legales[1]) {
        const c = Object.values(legales[1]);

        b = c.filter(e => e.legal === user.abogado || user.rol === "admin");
      }
      if (legales["G"]) {
        const d = Object.values(legales["G"]);

        b = [...b, ...d].filter(e => e.legal === user.abogado || user.rol === "admin");
      }

      setLegal(b);
      let abogadosList = b.filter(e => e.legal);
      if (abogadosList?.length) {
        const findAbogado = abogados.find((e) => e.codexterno === abogadosList[abogadosList.length - 1].legal);
        setAbogado(`${findAbogado.apellido} ${findAbogado.nombre} (${findAbogado.codexterno})`);
      }
    }

    return () => {
      setDeuda();
      setLegal();
      setAbogado();
      setPlanPago();
      setNroPlan();
    };
  }, [data]);

  const handleShow = (data) => {
    setPlanDePago(data);
    setShowPlan(true);
  };
  const handleClose = () => {
    setShowPlan(false);
  };

  return (
    <>
      {!loading && !((legal && legal.length) || (deuda && deuda.length) || (nroPlan && nroPlan.length)) ? (
        <>
          <br />
          <br />
          <div className="d-flex justify-content-center" style={{ fontSize: 18 }}>
            No posee deudas
          </div>
        </>
      ) : ""}
      {legal && legal.length ? (
        <Table className="subtable" striped bordered hover>
          <tbody>
            <tr>
              <td colSpan={4} className="subtable-subtitulo">Períodos {abogado ? abogado : ""} en Gestión Legal</td>
            </tr>
            <tr>
              <td className="subtable-key">Año</td>
              <td className="subtable-key">Período</td>
              <td className="subtable-key">Situación</td>
              <td className="subtable-key">Monto</td>
            </tr>
            {legal.length && legal.map((deuda, i) => {
              return <Fragment key={"deudas1-" + i}>
                <tr>
                  <td><span>{deuda.anio}</span></td>
                  <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                  <td><span>{deuda.situacion}</span></td>
                  <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                </tr>
              </Fragment>;
            })
            }
            <tr>
              <td colSpan={3} className="subtable-key">Total</td>
              <td className="subtable-key">
                $ {formatCapital(calcularTotal(legal))}
              </td>
            </tr>
          </tbody>
        </Table>
      ) : null}

      <br />
      {deuda && deuda.length ? (
        <Table className="subtable" striped bordered hover>
          <tbody>
            <tr>
              <td colSpan={3} className="subtable-subtitulo">Períodos Fuera de Gestión Legal</td>
            </tr>
            <tr>
              <td className="subtable-key">Año</td>
              <td className="subtable-key">Período</td>
              <td className="subtable-key">Monto</td>
            </tr>
            {deuda?.length && deuda.map((deuda, i) => {
              return <Fragment key={"deudas2-" + i}>
                <tr>
                  <td><span>{deuda.anio}</span></td>
                  <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                  <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                </tr>
              </Fragment>;
            })
            }
            <tr className="">
              <td className="subtable-key"><span>Total</span></td>
              <td></td>
              <td className="subtable-key d-flex">
                <span style={{ width: "100%" }}>
                  $ {formatCapital(calcularTotal(deuda))}
                </span>
              </td>
            </tr>
          </tbody>
        </Table>
      ) : null}

      <br />
      {planPago?.length ? (
        <Table className="subtable" striped bordered hover>
          <tbody>
            <tr>
              <td colSpan={2} className="subtable-subtitulo">
                PLANES DE PAGO
              </td>
            </tr>
            {
              nroPlan.length ? nroPlan.map((e, i) => {
                return (
                  <tr key={e.NRO_PLAN + e.RECURSO + i}>
                    <td >
                      NRO {e.NRO_PLAN}
                    </td>
                    <td>
                      <FontAwesomeIcon
                        icon={faEye}
                        size="lg"
                        className="ml-2"
                        onClick={() => handleShow(e)}
                      />
                    </td>
                  </tr>
                );
              })
                : null
            }
          </tbody>
        </Table>
      ) : ""}

      <br />
      {registros?.length ? (
        <Table className="subtable" striped bordered hover>
          <tbody>
            <tr>
              <td colSpan={2} className="subtable-subtitulo">
                RECURSOS
              </td>
            </tr>
            <tr>
              <td className="subtable-subtitulo">
                Apellido y Nombre
              </td>
              <td className="subtable-subtitulo">
                Titulo
              </td>
              <td className="subtable-subtitulo">
                DNI
              </td>
              <td className="subtable-subtitulo">
                Teléfono
              </td>
              <td className="subtable-subtitulo">
                Descripción
              </td>
              <td className="subtable-subtitulo">
                Subido por
              </td>
              <td className="subtable-subtitulo">
                Documentos
              </td>
            </tr>
            {
              registros.length ? registros.map((e) => {
                return (
                  <tr key={`registro-${e.id}`}>
                    <td >
                      {e.apellido_nombre}
                    </td>
                    <td>
                      {e.titulo}
                    </td>
                    <td>
                      {e.dni}
                    </td>
                    <td>
                      {e.telefono}
                    </td>
                    <td>
                      {e.descripcion}
                    </td>
                    <td>
                      {e.asignado}
                    </td>
                    <td>
                      {e.documentos}
                    </td>
                  </tr>
                );
              })
                : null
            }
          </tbody>
        </Table>
      ) : ""}

      {loading ? <LoadingModal show={loading} loading={true} /> : null}
      {showPlan ? <PlanDePagoModal show={showPlan} handleClose={handleClose} data={planDePago} imponible={record.NRO_INMUEBLE} recurso={record.RECURSO} /> : null}
    </>
  );
};